"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
var _remeda = require("remeda");
const settings = [{
  title: "Condition",
  description: "The condition for showing the spinner.",
  settings: _variables.ConditionVariable.settings
}];
class SpinnerBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "spinner");
    (0, _defineProperty2.default)(this, "conditional", true);
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "conditionVariable", void 0);
    this.param = param;
    let oldParam = param;
    if (oldParam !== null && oldParam !== void 0 && oldParam.left) {
      param.conditions = [(0, _remeda.clone)(oldParam)];
      delete oldParam.left;
    }
    this.conditionVariable = this.addBlockVariable(variableTypes.get("condition"), param, ["conditions"]);
  }
  renderValue() {
    let val = this.conditionVariable.value();
    return {
      value: !!val.value
    };
  }
}
exports.SpinnerBlock = SpinnerBlock;
(0, _defineProperty2.default)(SpinnerBlock, "settings", settings);
//# sourceMappingURL=SpinnerBlock.js.map